import { useState } from "react";
import { Button, Card, CardGroup, Divider, Dropdown, Header, Icon, Label, Segment } from "semantic-ui-react";
import { SitePhoto } from "../models/SitePhoto";
import ServerImage from "./common/ServerImage";
import AddSitePhotoModalContainer from "../containers/AddSitePhotoModalContainer";
import { UserFile } from "../models/UserFile";
import { FileMetaData } from "../models/FileMetaData";
import TempLocalImage from "./common/TempLocalImage";
import { SitePhotoInput } from "../models/globalTypes";
import { getSitePhotoTypeColor } from "../utils/sitePhoto";

interface Props {
  onSitePhotoClicked?: (photo: SitePhoto) => void;
  onNewSitePhotoClicked?: (photo: UserFile) => void;
  sitePhotos?: SitePhoto[];
  onAddSitePhotos?: (photo: SitePhotoInput) => void;
  onRemoveNewSitePhoto?: (id: string) => void;
  onRemoveSitePhoto?: (id: string) => void;
  addNewSitePhotoButtonVisible?: boolean;
}

const PermitSitePhotos = ({
  onSitePhotoClicked,
  onNewSitePhotoClicked,
  sitePhotos,
  onAddSitePhotos,
  onRemoveNewSitePhoto,
  onRemoveSitePhoto,
  addNewSitePhotoButtonVisible = true,
}: Props) => {
  const [openAddSitePhotoModal, setOpenAddSitePhotoModal] = useState(false);
  const [newSitePhotos, setNewSitePhotos] = useState<UserFile[]>([]);

  const handleAddSitePhoto = (comments: string, photo: UserFile) => {
    setOpenAddSitePhotoModal(false);
    setNewSitePhotos([...newSitePhotos, photo]);
    const fileMetaData = {
      id: photo.id,
      fileName: photo.file.name,
      contentType: photo.file.type,
    } as FileMetaData;
    const sitePhoto = { fileMetaData, comments } as SitePhotoInput;
    onAddSitePhotos && onAddSitePhotos(sitePhoto);
  };

  const handleRemoveNewSitePhoto = (id: string) => {
    setNewSitePhotos([...newSitePhotos.filter((p) => p.id !== id)]);
    onRemoveNewSitePhoto && onRemoveNewSitePhoto(id);
  };

  return (
    <>
      <Segment basic vertical>
        <Header as="h3">
          <Icon name="photo" />
          <Header.Content>Site photos</Header.Content>
        </Header>
        <Divider />

        <Card content style={{ "box-shadow": "0px 0px", backgroundColor: "transparent" }}>
          <Card.Content style={{ padding: "0px", margin: "0px" }}>
            <CardGroup itemsPerRow={3}>
              {sitePhotos &&
                sitePhotos.length > 0 &&
                sitePhotos.map((photo, index) => (
                  <Card
                    style={{ "box-shadow": "0px 0px", backgroundColor: "transparent" }}
                    key={index}
                    onClick={(e) => {
                      onSitePhotoClicked && onSitePhotoClicked(photo);
                    }}
                  >
                    <Label
                      color={getSitePhotoTypeColor(photo.type.key)}
                      empty
                      size="mini"
                      style={{ padding: "3px", width: "100%" }}
                    >
                      {onRemoveSitePhoto && (
                        <Button
                          floated="right"
                          circular
                          basic
                          icon="close"
                          size="mini"
                          style={{ padding: "0px", margin: "0px", "box-shadow": "0px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            onRemoveSitePhoto(photo.id);
                          }}
                        ></Button>
                      )}
                    </Label>

                    {photo.fileUrl ? (
                      <ServerImage key={index} src={photo.fileUrl} />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          aspectRatio: "4/3",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#e4e4e4",
                        }}
                      >
                        <Icon name="ban" size="large" color="grey" />
                      </div>
                    )}
                  </Card>
                ))}

              {newSitePhotos &&
                newSitePhotos.length > 0 &&
                newSitePhotos.map((photo, index) => (
                  <Card
                    style={{ "box-shadow": "0px 0px", backgroundColor: "transparent" }}
                    key={index}
                    onClick={(e) => {
                      onNewSitePhotoClicked && onNewSitePhotoClicked(photo);
                    }}
                  >
                    <Label empty size="mini" style={{ padding: "3px", width: "100%" }}>
                      {onRemoveNewSitePhoto && (
                        <Button
                          floated="right"
                          circular
                          basic
                          icon="close"
                          size="mini"
                          style={{ padding: "0px", margin: "0px", "box-shadow": "0px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveNewSitePhoto(photo.id);
                          }}
                        ></Button>
                      )}
                    </Label>
                    <TempLocalImage key={index} file={photo.file} rounded />
                  </Card>
                ))}
            </CardGroup>
          </Card.Content>
        </Card>

        {addNewSitePhotoButtonVisible && (
          <Segment basic style={{ padding: "0px", margin: "0px" }}>
            <Label as="a" size="large" style={{ padding: "5px" }}>
              <Icon size="small" name="plus" />
              <Dropdown text="Add Photo" onClick={() => setOpenAddSitePhotoModal(true)} icon={null}></Dropdown>
            </Label>
          </Segment>
        )}
      </Segment>

      {onAddSitePhotos && (
        <AddSitePhotoModalContainer
          open={openAddSitePhotoModal}
          onPhotoAdded={handleAddSitePhoto}
          onClose={() => {
            setOpenAddSitePhotoModal(false);
          }}
        ></AddSitePhotoModalContainer>
      )}
    </>
  );
};

export default PermitSitePhotos;
